import { render, staticRenderFns } from "./ManifestPublic.vue?vue&type=template&id=40b764e0&"
import script from "./ManifestPublic.vue?vue&type=script&lang=js&"
export * from "./ManifestPublic.vue?vue&type=script&lang=js&"
import style0 from "./ManifestPublic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports